<template>
  <div class="about-us">
    <!-- <Header title="关于我们" background="white" /> -->
    <div class="content">
      <h3 class="title">{{ info.title }}</h3>
      <p class="desc">{{ info.createdAt }}</p>
      <div class="line"></div>
      <div class="message-content" v-html="info.content"></div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {
      info: {
        title: "",
        createdAt: "",
        content: "",
      },
      // info: {
      //   title: "波波商城",
      //   createdAt: "2021-03-02",
      //   content:
      //     "<p>左手交易手续费，右手项目上币费，在疯狂增长的数字货币市场，交易所毋容置疑是最大赢家，许多创业者对其趋之若鹜。同时，黑客针对交易所的安全攻击越来越多，监管所带来的不确定性也越来越大。</p><br /><img src='https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.ewebweb.com%2Fuploads%2F20191230%2F14%2F1577685866-JkUhPyKGrQ.jpg&refer=http%3A%2F%2Fimg.ewebweb.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1616914244&t=083cd556d5136239a6f350ba7defc80c' /><br /><br /><br /><p>左手交易手续费，右手项目上币费，在疯狂增长的数字货币市场，交易所毋容置疑是最大赢家，许多创业者对其趋之若鹜。同时，黑客针对交易所的安全攻击越来越多，监管所带来的不确定性也越来越大。</p>",
      // },
    };
  },
  methods: {},
  components: {},
  created() {
    this.$post({
      module: "Content",
      interface: "4003",
      data: { name: "about_us" },
    }).then((res) => {
      // console.log("关于我们", res);
      this.info = res;
    });
  },
};
</script>

<style scoped lang="less">
.about-us {
  background-color: #fbfbfb;
  height: 100vh;
  overflow: auto;

  .content {
    padding: 14px;
    background-color: #fff;

    .title {
      font-size: 20px;
      margin-bottom: 10px;
    }

    .desc {
      font-size: 12px;
      color: #999999;
      margin-bottom: 10px;
    }

    .line {
      background-color: #f7f7f7;
      height: 1px;
      margin-bottom: 11px;
    }

    .message-content {
      width: 100%;

      /deep/img {
        max-width: 100%;
      }
    }
  }
}
</style>